import styled from 'styled-components';
export const StyledButton = styled.button `
  background: ${({ outline, variant }) => outline
    ? 'transparent'
    : variant === 'primary'
        ? '#323333'
        : variant === 'secondary'
            ? '#626368'
            : variant === 'danger'
                ? '#E30613'
                : variant === 'reminder'
                    ? '#AE0F0A'
                    : variant === 'success'
                        ? '#34C38F'
                        : variant === 'info'
                            ? '#0077D7'
                            : variant === 'warning'
                                ? '#F1B44C'
                                : variant === 'light'
                                    ? '#f8f9fa'
                                    : variant === 'link'
                                        ? 'transparent'
                                        : variant};

  color: ${({ variant, outline }) => outline
    ? variant === 'primary'
        ? '#323333'
        : variant === 'secondary'
            ? '#626368'
            : variant === 'danger'
                ? '#E30613'
                : variant === 'reminder'
                    ? '#AE0F0A'
                    : variant === 'success'
                        ? '#34C38F'
                        : variant === 'info'
                            ? '#0077D7'
                            : variant === 'warning'
                                ? '#F1B44C'
                                : variant === 'light'
                                    ? '#000'
                                    : variant === 'link'
                                        ? '#007bff'
                                        : variant
    : '#fff'};

  border: ${({ variant, outline }) => outline ? '1px solid' : variant !== 'light' ? 'none' : '1px solid'};

  border-color: ${({ variant }) => variant === 'primary'
    ? '#323333'
    : variant === 'secondary'
        ? '#626368'
        : variant === 'danger'
            ? '#E30613'
            : variant === 'reminder'
                ? '#AE0F0A'
                : variant === 'success'
                    ? '#34C38F'
                    : variant === 'info'
                        ? '#0077D7'
                        : variant === 'warning'
                            ? '#F1B44C'
                            : variant === 'light'
                                ? '#C6C6C6'
                                : variant === 'link'
                                    ? 'transparent'
                                    : variant};

  ${({ rounded }) => rounded ? `border-radius: 6px;` : `border-radius: 0;`}

  ${({ block }) => block ? `display: block; width:100%;` : ` display: flex; min-width: 150px;`}

    ${({ disabled }) => disabled === true
    ? `opacity: 0.5;pointer-events: none;user-select: none;`
    : ``}

    justify-content: center;
  align-items: center;
  min-height: 45px;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  padding: 12px 10px;
  font-size: 16px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:hover {
    opacity: ${({ disabled }) => disabled === true ? `0.5` : `0.85`};
    background: ${({ variant }) => variant === 'primary'
    ? '#323333'
    : variant === 'secondary'
        ? '#626368'
        : variant === 'danger'
            ? '#E30613'
            : variant === 'reminder'
                ? '#AE0F0A'
                : variant === 'success'
                    ? '#34C38F'
                    : variant === 'info'
                        ? '#0077D7'
                        : variant === 'warning'
                            ? '#F1B44C'
                            : variant === 'light'
                                ? '#f9fafb'
                                : variant === 'link'
                                    ? 'transparent'
                                    : variant};
    color: ${({ variant, outline }) => outline
    ? ['primary', 'secondary', 'danger', 'reminder', 'success'].includes(variant)
        ? '#fff;'
        : ['info', 'warning'].includes(variant)
            ? '#000'
            : variant === 'light'
                ? '#2B2828'
                : variant === 'link'
                    ? '#0056b3'
                    : '#F8F8FB'
    : variant === 'light'
        ? '#2B2828'
        : variant === 'link'
            ? '#0056b3'
            : '#fff'};
    border-color: ${({ variant }) => variant === 'primary'
    ? '#323333'
    : variant === 'secondary'
        ? '#626368'
        : variant === 'danger'
            ? '#E30613'
            : variant === 'reminder'
                ? '#AE0F0A'
                : variant === 'success'
                    ? '#34C38F'
                    : variant === 'info'
                        ? '#0077D7'
                        : variant === 'warning'
                            ? '#F1B44C'
                            : variant === 'light'
                                ? '#C6C6C6'
                                : variant};

    text-decoration: ${({ variant }) => variant === 'link' ? `underline` : ``};
  }
`;
//# sourceMappingURL=index.js.map